export const vacancyDictionary = {
  activeVacancies: 'Aktiv vakansiyalar',
  archiveVacancies: 'Arxiv vakansiyalar',
  vacancies: 'Vakansiyalar',
  graphic: 'Grafik',
  vacancyName: 'Vakansiya Nomi',
  salary: 'Maosh',
  sureToArchiveVacancy: 'Vakansiyani arxivlashga aminmisiz ?',
  showImgFile: 'Rasm faylni ko`rsating',
  add: 'Qo`shish',
  save: 'Saqlash',
  cancel: 'Bekor qilish',
  requiredImage: 'Rasm faylni tanlang',
  search: 'Qidirish',
  branch: 'Filial',
  datePicker: 'Vaqt bo`yicha',
  clear: 'Tozalash',
  select: 'Tanlang',
  requiredField: 'Maydon toldirish shart',
  aboutVacancy: 'Vakansiya haqida',
  vacancySalary: 'Vakansiya maoshi',
  vacancyGraphic: 'Vakansiya grafigi',
  vacancyBranch: 'Vakansiya filiali',
  sureToBackVacancy: 'Vakansiyani faollashtirishga aminmisiz ?',
  images: 'Rasmlar',
  FAQ: 'FAQ',
  news: 'Yangiliklar',
  ourTeam: 'Bizning Jamoa',
  requiredImgFormat: 'Rasm formati togri kelmadi',
  FAQTitle: 'FAQ Sarlavhasi',
  sureToDeleteFAQ: 'Ushbu faqni o`chirmoqchimisiz',
  question: 'Savol',
  answer: 'Javob',
  activeNews: 'Aktiv Yangiliklar',
  archiveNews: 'Arxiv Yangiliklar',
  topNew: 'Top yangilik',
  recommendedNew: 'Tavsiya etilgan yangilik',
  newsName: 'Yangilik mavzusi',
  newsCategory: 'Kategoriya',
  newsAuthor: 'Muallif',
  createdAt: 'Qoshilgan sana',
  actions: 'Harakatlar',
  sureToArchiveNew: 'Bu yangilikni arxivlashga ishonchingiz komilmi?',
  yes: 'Ha',
  no: 'Yo`q',
  addTopNew: 'Top yangilik qo`shish',
  addRecommendNew: 'Tavsiya etilgan yangilik qo`shish',
  sureToUnArchiveNew: 'Bu yangilikni arxivdan chiqarishga ishonchingiz komilmi?',
  enterAuthor: 'Muallifni kiriting',
  shortComment: 'Qisqacha izoh',
  metaDataTitle: 'Metadata sarlavhasi (SEO)',
  metaDataDesc: 'Metadata tavsifi (SEO)',
  newsContent: 'Yangilik mazmuni',
  searchPlaceholder: 'Ism-familiya, tel raqam yoki email ',
  hash: '#',
  fullName: 'Ism-familiya',
  phoneNumber: 'Tel raqam',
  email: 'Elektron pochta',
  resumeLink: 'Resume havolasi',
  resumeFile: 'Resume fayl',
  sentTime: 'Jo`natilgan vaqt',
  successfullyEdited: 'Muvaffaqiyatli tahrirlandi',
  successfullyAdded: 'Muvaffaqiyatli qo`shildi',
  all: 'Barchasi',
  edit: 'Tahrirlash',
  candidates: 'Nomzodlari',
  download: 'Yuklash',
  link: 'Havola',
  newsCategories: 'Yangiliklar Kategoriyasi',
  categoryName: 'Kategoriya Nomi',
  successFullyArchived: 'Muvaffaqiyatli arxivlandi',
  successFullyUnArchived: 'Muvaffaqiyatli arxivdan chiqarildi',
  sureToUnRecommendNew: 'Ushbu yangilikni tavsiyalardan olib tashlamoqchimisiz?',
  sureToUnTopNew: 'Ushbu yangilikni birinchi oʻrindan olib tashlamoqchimisiz?',
  sureToRecommendNew: 'Ushbu yangilikni tavsiya qilmoqchimisiz?',
  sureToTopNew: 'Ushbu yangilikni birinchi oʻringa qoʻymoqchimisiz?',
  watchedCount: "Ko'rishlar soni",
  successfullyDeleted: 'Muvaffaqiyatli o`chirildi',
}
